import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormlyModule, FORMLY_CONFIG } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { registerTranslateExtension } from './translate.extension';

@NgModule({
    declarations: [],
    imports: [CommonModule, FormlyModule.forChild()],
    providers: [
        {
            provide: FORMLY_CONFIG,
            multi: true,
            useFactory: registerTranslateExtension,
            deps: [TranslateService],
        },
    ],
})
export class ExtensionModule {}
